var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.renderForm)?_c('laraform-override',{ref:"laraFormComponent",attrs:{"form":_vm.form},on:{"response":function($event){return _vm.checkResponse($event)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }